import { App } from "app";
import { NeighborwhoodDataDeletion } from "dataDeletion/neighborwhood";
import { NeighborwhoodPrivacyPolicy } from "privacyPolicies/neighborwhood";
import { ReminderBroPrivacyPolicy } from "privacyPolicies/reminderBro";
import { NeighborwhoodTermsOfService } from "termsOfService/neighborwhood";

export const Router = () => {
  const currentRoute = window.location.pathname;

  if (currentRoute === "/privacy-policy/reminder-bro") {
    return <ReminderBroPrivacyPolicy />;
  }

  if (currentRoute === "/privacy-policy/neighborwhood") {
    return <NeighborwhoodPrivacyPolicy />;
  }

  if (currentRoute === "/data-deletion/neighborwhood") {
    return <NeighborwhoodDataDeletion />;
  }

  if (currentRoute === "/terms-of-service/neighborwhood") {
    return <NeighborwhoodTermsOfService />;
  }

  return <App />;
};
